<template>
    <div>
        <div data-v-109177d0="" icon="error" v-if="isIEBrowser" cookie="IECookie0.44864076497587435"
            message="<strong>Internet explorer is not supported:</strong> You are using unsupported browser; some BPM function may not work properly."
            color="danger" class="mc-announcement">
            <div class="mc-announcement__content  mc-announcement__content--bg-danger">
                <div class="mc-announcement__icon">
                    <mcc-icon class="mcc-icon--inverse" name="error" height="42" width="42"></mcc-icon>
                </div>
                <div class="mc-announcement__message">
                    <strong>Internet explorer is not supported:</strong> You are using unsupported browser; some BPM
                    function may not work properly.
                </div>
                <div class="mc-announcement__actions">
                    <button class="mc-announcement__close-button" aria-label="Close"
                        @click="closeAnnouncement">×</button>
                </div>
            </div>
        </div>
        <div class="mcc-dialog-overlay">

            <dialog class="mcc-dialog mcc-dialog--danger" @close="closeIEDialog($event)" id="browser-message-dialog">
                <section>
                    <div class="mcc-dialog__header">
                        <h2 class="h4">Warning !!</h2>
                    </div>
                    <div class="mcc-dialog__body">
                        <p><strong>Internet explorer is not supported:</strong> You are using an unsupported browser;
                            some BPM functions may not work properly.
                        </p>
                    </div>
                    <div class="mcc-dialog__footer">

                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--outline">Cancel</button>
                            <button type="submit" class="mcc-button mcc-button--danger">OK</button>
                        </div>
                    </div>
                </section>
            </dialog>
        </div>
        <div v-if="showLoader" class="headerClass">
            <div class="spinner-overlay">
                <div style="position:absolute"></div>
                <div class="spinner-flex">
                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                    </svg>
                </div>
            </div>
        </div>
        <div class="mcc-drawer-frame">
            <LeftContainer v-if="!showLoader" :leftContainerProperty="leftContainerProperty" ref="leftcontainer" />
            <div v-if="$store.getters.getSmallScreenStatus" class="mcc-drawer__scrim" @click="$refs.leftcontainer.toggleDrawer()"></div>
            <div class="mcc-drawer-app-content" tabindex="0">
                <Navbar :navbarProperty="navbarProperty" v-if="!showLoader" />
                <div class="mcc-navigation-header--fixed-adjust no-print"></div>
                <div class="mcc-container " :class="$store.getters.getEndDrawerStatus ? 'end-drawer-padding--adjust' : ''"
                    content v-if="!showLoader">
                    <div class="mcc-container" main id="mainPageMiddleContainer">
                        <router-view></router-view>
                        <UserDefinedTheme></UserDefinedTheme>
                    </div>
                    <div class="mcc-dialog-overlay">

                        <dialog class="mcc-dialog mcc-dialog--primary mcc-dialog--xs" 
                            id="sessionTimeOutModal">
                            <form novalidate>
                                <section>
                                    <div class="mcc-dialog__header">
                                        <h2 class="h4">Session timeout</h2>
                                    </div>
                                    <div class="mcc-dialog__body">
                                        <div class="mcc-row">

                                            <div class="mcc-col">
                                                <span>
                                                    You're being timed out due to inactivity.Please choose to stay
                                                    signed in or to logoff.Otherwise,
                                                    you will logged off automatically.
                                                </span>

                                            </div>

                                        </div>
                                    </div>
                                    <div class="mcc-dialog__footer mu-justify-content-between">
                                        <div>
                                            <button class="mcc-button mcc-button--secondary" id="stayLoggedInBtn"
                                                @click="updateUserSessionTimeOut"><span class="mcc-button__label"><span
                                                        id="stayLoggedInmsg">Stay logged in</span></span></button>
                                        </div>
                                        <div class="mcc-button-group mcc-button-group--spaced">                                            
                                            <button type="button" class="mcc-button mcc-button--primary" @click="logouFromSessionTimeOut()">Log
                                                off</button>
                                        </div>
                                    </div>
                                </section>
                            </form>
                        </dialog>
                    </div>
                    <About></About>
                </div>
                <div :key="footerCount" :class="[fixedFooter ? 'fixed-footer-padding-adjust' : '', $store.getters.getEndDrawerStatus ? 'end-drawer-padding--adjust' : '','no-print' ]">
                    <footer class="mcc-footer mu-d-flex mu-justify-content-center"
                        :class="[fixedFooter ? 'fixedPageFooter' : '', $store.getters.getDrawerStatus ? 'fixedPageFooterDrawer' : '']">
                        <button class="mcc-button mcc-button--icon-only mcc-button--anchor" aria-label="copyright">
                            <mcc-icon name="copyright" aria-hidden="true"></mcc-icon>
                        </button><span>Advanced Business Software and Solutions Limited 2002 - {{ new
                            Date().getFullYear() }}</span>
                    </footer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import {
    EventBus
} from "../services/event-bus.js";
import Utils from "@/script_utils";

import NavigationButton from "@/components/customComponents/NavigationButton.vue";
import LeftContainer from "@/components/customComponents/LeftContainer.vue";
import RightContainer from "@/components/customComponents/RightContainer.vue";
import Navbar from "@/components/customComponents/Navbar.vue";
import constants from "../constants";
import AdminHttpAPI from "../services/AdminHttpAPI";
import AdminThemesAPI from "@/services/AdminThemesAPI";
import UserAPI from "@/services/UserAPI";
import About from "./About/About";
import constantMessages from "../messages";
import UserDefinedTheme from '@/components/customComponents/UserDefinedTheme.vue'
export default {
    name: "MainPage",
    components: {
        NavigationButton,
        LeftContainer,
        RightContainer,
        Navbar,
        About,
        UserDefinedTheme
    },
    data() {
        return {
            showLoader: false,
            fixedFooter: false,
            footerCount: 0,
            isIEBrowser: false,
            originalSessionTimeOut: 1500,
            sessionTimeOutTimer: 1500,
            isModalOpen: false,
            leftContainerProperty: {},
            ieCookieName: 'IECookie' + Math.random(),
            navbarProperty: {},
            CSRF: 'UNKNOWN',
            resetSpinner: false,
            notifMsg: 'Hello ',
            notifColor: 'success',
            notifIcon: 'ok',
            showNotif: false
        };
    },
    created() {
        var self = this;
        self.showLoader = true;
        EventBus.$on("updateFooter", result => {
            self.fixedFooter = result;
            self.footerCount = self.footerCount + 1;
        });

        EventBus.$on("update-pageTitle", result => {
            let pageTitle = result;
            if (self.$store.getters.getThemeData && pageTitle) {
                pageTitle += ' - ' + self.$store.getters.getThemeData.productName;
            }
            document.title = pageTitle;
        });

        EventBus.$on("success-notification", result => {
            self.showToast('success',result.msg)
        });
        EventBus.$on("error-notification", result => {
            self.showToast('danger',result.msg)
        });
        EventBus.$on("warning-notification", result => {
            self.showToast('warning',result.msg)
        });
        this.configureRefreshSession();

        axios.get(constants.BASE_URL + "/usersgroups/usersAPI/defaultWorkplace", {
            withCredentials: true
        })
            .then(response => {
                axios.get(constants.BASE_URL + "/usersgroups/usersAPI/userInfo", {
                    withCredentials: true
                })
                    .then(userInfoReponse => {
                        AdminThemesAPI.getTheme()
                            .then(result => {

                                if (!result) {

                                    axios.defaults.withCredentials = true;
                                    axios
                                        .post(constants.BASE_URL + "/usersgroups/usersAPI/updateTenant", null, {
                                            params: {
                                                selectedWrf: response.data.DEFAULT_WORKPLACE,
                                            }
                                        })
                                        .then((response) => { })
                                }
                            });
                    })
                axios.get(constants.BASE_URL + "/usersgroups/usersAPI/init", {
                    withCredentials: true
                })
                    .then(response => {
                        self.$store.dispatch("fetchUserRoles", response.data.ROLES);
                        self.$store.dispatch("fetchIsUserLogin", true);
                        self.leftContainerProperty["monitorEnabled"] = response.data.MONITOR_ENABLED;
                        self.leftContainerProperty["monitorURL"] = response.data.MONITOR_URL;
                        self.navbarProperty["monitorEnabled"] = response.data.MONITOR_ENABLED;
                        self.navbarProperty["monitorURL"] = response.data.MONITOR_URL;
                        self.$store.dispatch("fetchEnablePrivacyPolicy", response.data.ENABLE_PRIVACY_POLICY);
                        self.$store.dispatch("fetchPrivacyPolicyLinkName", response.data.PRIVACY_POLICY_LINK_NAME);
                        self.$store.dispatch("fetchPrivacyPolicyLinkUrl", response.data.PRIVACY_POLICY_LINK_URL);
                        self.$store.dispatch("fetchHelpUrl", response.data.HELP_URL)
                        constantMessages.URL_UTILS.updateRootUrl(response.data.HELP_URL);
                        constantMessages.BREADCRUMB_HELP = constantMessages.URL_UTILS.getBreadCrumbHelp();
                        self.navbarProperty["userName"] = response.data.USER_INFO.username;
                        self.CSRF = self.getCookie('XSRF-TOKEN');
                        $('head').append(`<meta name="_csrf" content="${this.CSRF}" />`);
                        $('head').append(`<meta name="_csrf_header" content="X-XSRF-TOKEN" />`);
                        axios.all([
                            AdminHttpAPI.getCategoryMenu(),
                            AdminHttpAPI.getCustomViews(),
                            AdminHttpAPI.getThemeData(),
                            AdminThemesAPI.getAllUserDefinedThemes(),
                            UserAPI.getUserProfileDetails(),
                            UserAPI.getWorksPlace(response.data.USER_INFO.username)
                        ]).then(responseArr => {
                            self.$store.dispatch("fetchCategories", responseArr[0])
                            self.$store.dispatch("fetchCustomViews", responseArr[1])
                            self.$store.dispatch("fetchThemeData", responseArr[2])
                            self.$store.dispatch("fetchUserDefinedThemes", responseArr[3])
                            if (responseArr[4] == null) {
                                EventBus.$emit('error-notification', {
                                    "msg": "Error while fetching user profile"
                                });
                            } else {
                                self.$store.dispatch("fetchUserProfile", responseArr[4].user)
                            }
                            self.$store.dispatch('updateSelectedWorksplace', responseArr[5])
                            self.$store.dispatch('updateWorksplaceReferences', responseArr[5])
                            self.$store.dispatch('fetchIsAdvancedSSO', responseArr[5])
                            EventBus.$emit("updateFooter", responseArr[2].fixedFooter);
                        }).finally(() => {
                            self.showLoader = false;
                            let oldRoute = localStorage.getItem("oldURL");
                            let coreAppLogout = localStorage.getItem("coreAppLogout");
                            localStorage.removeItem("oldURL");
                            localStorage.removeItem("coreAppLogout");
                            if (coreAppLogout != null && coreAppLogout != "") {
                                setTimeout(() => {
                                    window.location = coreAppLogout;
                                }, 2000);
                            } else if (oldRoute != null && oldRoute != "" && oldRoute != self.$router.currentRoute.path) {
                                setTimeout(() => {
                                    self.$router.push(
                                        oldRoute
                                    );
                                }, 2000);
                            }
                            setTimeout(() => {
                                self.handleIEBrowserMessage();
                            }, 2000);
                        })
                        self.handleSessionTimeOut();
                    })
                    .catch(error => {
                        localStorage.setItem(
                            "oldURL", self.$router.currentRoute.path
                        );
                        window.location = process.env.VUE_APP_CONTEXT_PATH + "/unauthorizedError";
                    });
            })
            .catch(error => {
                if (error.message === 'Network Error') {
                    localStorage.setItem("oldURL", self.$router.currentRoute.path);
                    this.$router.push(process.env.VUE_APP_CONTEXT_PATH + "/applicationError");
                } else if (error.response && (error.response.status >= 502 && error.response.status <= 504)) {
                    localStorage.setItem("oldURL", self.$router.currentRoute.path);
                    this.$router.push(process.env.VUE_APP_CONTEXT_PATH + "/applicationError");
                } else {
                    window.location = process.env.VUE_APP_CONTEXT_PATH + "/unauthorizedError";
                }
            })
    },
    methods: {
        showToast(color, title) {
      const getIcon = (color) => {
        switch (color) {
          case 'info':
            return 'info_popup'
          case 'success':
            return 'ok'
          case 'warning':
            return 'error'
          case 'danger':
            return 'stop_sign'
          case 'primary':
            return 'page'
          default:
            return 'not_found'
        }
      }

      const buildToastText = () => {
        return `
          <mcc-icon name="${getIcon(color)}" icon-set="fluency-filled" aria-hidden="true"></mcc-icon>
          <div class="mu-d-flex mu-flex-column">
            <div class="mu-fw-semi-bold">${title}</div>
          </div>
        `
      }

      Toastify({
        text: buildToastText(),
        escapeMarkup: false,
        duration: 5000, 
        newWindow: true,
        close: true,
        className: `mcc-alert  mcc-alert--${color} [mu-d-flex mu-flex-row mu-p-04 mu-px-05]`,
        gravity: "top",
        position: "right", 
        stopOnFocus: true, 
      }).showToast() 
    },
        closeAnnouncement() {
            const self = this;
            self.isIEBrowser = false;
        },
        handleIEBrowserMessage() {
            var isIE = Utils.isIEBrowser();
            var self = this;
            if (isIE) {
                self.isIEBrowser = isIE;
            }
        },
        handleSessionTimeOut() {
            var self = this;
            AdminHttpAPI.getSessionTimeOut()
                .then(result => {
                    self.originalSessionTimeOut = result;
                    self.sessionTimeOutTimer = result;
                    self.handleSessionTimeOutInteval();
                });
            axios.interceptors.request.use(function (config) {
                self.sessionTimeOutTimer = self.originalSessionTimeOut;
                return config;
            }, function (err) {
                return Promise.reject(err);
            });

        },
        logouFromSessionTimeOut() {
            this.$router.push(process.env.VUE_APP_CONTEXT_PATH + "/sessionLogout")
        },
        updateUserSessionTimeOut() {
            AdminHttpAPI.getSessionTimeOut();
        },
        handleSessionTimeOutInteval() {
            var self = this;
            $("#sessionTimeOutModal").on('close', function (e) {
                self.isModalOpen = false;
            });
            setInterval(function () {
                self.sessionTimeOutTimer = parseInt(self.sessionTimeOutTimer) - 1;
                if (self.sessionTimeOutTimer < 30 && self.sessionTimeOutTimer > 0) {
                    $('#stayLoggedInmsg').html(
                        "Stay logged in (" +
                        self.sessionTimeOutTimer.toString() + ")")
                    if (!self.isModalOpen) {
                        $("#sessionTimeOutModal").removeClass("d-none");
                        document.getElementById("sessionTimeOutModal").show();
                        self.isModalOpen = true;
                    }
                    if (self.sessionTimeOutTimer < 5) {
                        $('#stayLoggedInBtn').prop('disabled', true);
                    } else {
                        $('#stayLoggedInBtn').prop('disabled', false);
                    }

                } else if (self.sessionTimeOutTimer <= 0) {
                    localStorage.setItem(
                        "oldURL", self.$router.currentRoute.path
                    );
                    self.logouFromSessionTimeOut();
                    self.sessionTimeOutTimer = 1000;

                } else if (self.isModalOpen) {
                    document.getElementById("sessionTimeOutModal").close();
                    self.isModalOpen = false;
                }
            }, 1000);
        },
        configureRefreshSession() {
            const tokenRefreshUrl = process.env.VUE_APP_CONTEXT_PATH + "/tokenrefresh";

            axios.interceptors.response.use(
                response => (response),
                async error => {
                    const originalConfig = error.config;

                    if (error.response) {
                        if (error.response.status === 401) {
                            if (error.response.config.url === tokenRefreshUrl) {
                                localStorage.setItem("returnUrl", this.$router.currentRoute.path);
                                window.location = process.env.VUE_APP_CONTEXT_PATH + "/login";
                                return;
                            } else if (!originalConfig._retry) {
                                originalConfig._retry = true;

                                try {
                                    await axios.get(tokenRefreshUrl, {
                                        withCredentials: true
                                    });
                                    return axios(originalConfig);
                                } catch (_error) {
                                    if (_error.response && _error.response.data) {
                                        return Promise.reject(_error.response.data);
                                    }
                                    return Promise.reject(_error);
                                }
                            }
                        }
                        if (error.response.status === 403 && error.response.data) {
                            return Promise.reject(error.response.data);
                        }
                    }
                    return Promise.reject(error);
                }
            );
        },
        getCookie(name) {
            if (!document.cookie) {
                return null;
            }
            const xsrfCookies = document.cookie.split(';')
                .map(c => c.trim())
                .filter(c => c.startsWith(name + '='));

            if (xsrfCookies.length === 0) {
                return null;
            }
            return decodeURIComponent(xsrfCookies[0].split('=')[1]);
        },
    }
};
</script>

<style scoped>
.headerClass {
    position: relative;
    width: 100vw;
    height: 100vh;
}

mcc-icon {
    align-items: center;
}

.mc-announcement {
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 3003
}

.mc-announcement__content--bg-danger {
    color: #fff;
    background-color: #dc3545
}

.mc-announcement__content {
    justify-content: space-between;
    align-items: center;
    height: 65px;
    display: flex
}

.mc-announcement__icon {
    height: inherit;
    width: 70px;
    justify-content: center;
    background-color: #bd2130;
    display: flex
}

.mc-announcement__message {
    flex-grow: 2;
    margin-left: 10px
}

.mc-announcement__actions,
.mc-announcement__close-button {
    align-items: center;
    display: flex
}

.mc-announcement__close-button {
    padding: 0;
    border: 0;
    cursor: pointer;
    width: 32px;
    height: 65px !important;
    background-color: hsla(0, 0%, 100%, .2);
    justify-content: center;
    margin-left: 1.5rem
}

.mc-announcement__close-button-span {
    font-size: 25px;
    line-height: 1;
    color: #fff
}
</style>
